export const CompanyStatus = {
  /**
   * Empresa criada via seed ou cadastro inicial, sem dono no sistema ainda.
   * Pode aparecer no B2C com limitações, mas não opera de fato.
   * Estado inicial padrão.
   */
  PENDING_ONBOARDING: 'PENDING_ONBOARDING',

  /**
   * Empresa já foi reivindicada (claim feito com sucesso).
   * Existe pelo menos um ADMIN vinculado.
   * Ainda não está pronta para operar (faltam serviços, profissionais, horários, etc).
   */
  CLAIMED: 'CLAIMED',

  /**
   * Empresa totalmente configurada e pronta para operar.
   * Pode aparecer normalmente no B2C e receber agendamentos reais.
   */
  ACTIVE: 'ACTIVE',
} as const;

export type CompanyStatus = (typeof CompanyStatus)[keyof typeof CompanyStatus];
